/** */
class Environment {

    /** */
    public static get environmentName(): string | undefined {
        return process.env.REACT_APP_ENVIRONMENT?.toLowerCase();
    }

    /** */
    public static get isLocal(): boolean {
        return Environment.environmentName === 'local';
    }

    /** */
    public static get isDevelopment() {
        return Environment.environmentName === 'azdev';
    }

    /** */
    public static get isTest() {
        return Environment.environmentName === 'aztest';
    }

    /** */
    public static get isProduction() {
        return Environment.environmentName === 'azprod';
    }

}

export default Environment;
